import { definePlugin, nodeFromJSON } from "prosekit/core";
import { Plugin, PluginKey } from "prosekit/pm/state";
import { jsonFromHTML } from "prosekit/core";
import { htmlFromMarkdown } from "../markdown";

// Handles conversion of pasted plain text (markdown) into editor state
// Is skipped if html is pasted
export function definePasteConversion() {
  return definePlugin(
    new Plugin({
      key: new PluginKey("prosekit-paste-conversion"),
      props: {
        handlePaste: (view, event) => {
          if (event.clipboardData?.getData("text/html")) return false;

          const text = event.clipboardData?.getData("text/plain");
          if (!text) return false;

          // link only pasting is handled separately by the link extension (via basic extensions)
          if (text.match(/^https?:\/\//)) return false;

          const html = htmlFromMarkdown(text);
          const json = jsonFromHTML(html, { schema: view.state.schema });
          const node = nodeFromJSON(json, { schema: view.state.schema });

          let tr = view.state.tr;
          const { from, to } = view.state.selection;

          // Check if we're in an empty paragraph and the pasted content starts with a block element
          const $from = view.state.doc.resolve(from);
          const currentNode = $from.parent;
          const isEmptyParagraph =
            currentNode.type.name === "paragraph" &&
            currentNode.textContent === "" &&
            from === to;

          const firstChildIsBlock =
            node.firstChild &&
            view.state.schema.nodes[
              node.firstChild.type.name
            ]?.spec.group?.includes("block");

          if (isEmptyParagraph && firstChildIsBlock) {
            // Delete the empty paragraph and insert the content
            tr = tr
              .delete($from.before(), $from.after())
              .insert($from.before(), node.content);
          } else {
            tr = tr.replaceSelectionWith(node);
          }

          view.dispatch(tr);

          return true;
        },
      },
    }),
  );
}
